/**
 * BIDC page namespaces shared by the app-level pathname routing and pages
 * that still publish their namespace in the URL for the PHP host.
 */
export const BIDC_PAGE_NAMESPACES = {
  DEFAULT: "ns:default",
  BILLING: "ns:billing",
  COMPANY_PAYMENT_MODAL: "ns:company-payment-modal",
  DRAWER: "ns:drawer",
  EVENTS: "ns:events",
  EVENTS_CALENDAR: "ns:eventsCalendar",
  EXPIRED: "ns:expired",
  HEADER: "ns:header",
  ESTIMATE_LIST: "ns:estimateList",
  MODAL: "modal",
  UNSCHEDULED_WORK_LIST: "ns:unscheduledWorkList",
  UPGRADE: "ns:upgrade",
  WAITLIST: "ns:waitlist",
  WAITLIST_DRAWER: "ns:waitlistDrawer",
} as const;

export type BidcPageNamespace =
  (typeof BIDC_PAGE_NAMESPACES)[keyof typeof BIDC_PAGE_NAMESPACES];

const PAGE_NAMESPACE_BY_PATHNAME = new Map<string, BidcPageNamespace>([
  ["/billing", BIDC_PAGE_NAMESPACES.BILLING],
  ["/calendar", BIDC_PAGE_NAMESPACES.EVENTS_CALENDAR],
  ["/events", BIDC_PAGE_NAMESPACES.EVENTS],
  ["/expired", BIDC_PAGE_NAMESPACES.EXPIRED],
  ["/finances/estimates", BIDC_PAGE_NAMESPACES.ESTIMATE_LIST],
  [
    "/partials/company-payment-method-modal",
    BIDC_PAGE_NAMESPACES.COMPANY_PAYMENT_MODAL,
  ],
  ["/partials/drawer", BIDC_PAGE_NAMESPACES.DRAWER],
  ["/partials/header", BIDC_PAGE_NAMESPACES.HEADER],
  ["/partials/modal", BIDC_PAGE_NAMESPACES.MODAL],
  ["/partials/waitlist-drawer", BIDC_PAGE_NAMESPACES.WAITLIST_DRAWER],
  ["/team/unscheduled-work", BIDC_PAGE_NAMESPACES.UNSCHEDULED_WORK_LIST],
  ["/team/waitlist", BIDC_PAGE_NAMESPACES.WAITLIST],
  ["/upgrade", BIDC_PAGE_NAMESPACES.UPGRADE],
]);

export function getPageNamespace(pathname: string): BidcPageNamespace {
  return (
    PAGE_NAMESPACE_BY_PATHNAME.get(pathname) ?? BIDC_PAGE_NAMESPACES.DEFAULT
  );
}
